import { createRef, useEffect } from 'react'
import { ParkingLayoutProps } from './SingleParkingMap'

export const ParkingN = (props: ParkingLayoutProps) => {
  const ref = createRef<any>()

  useEffect(() => {
    props.available.forEach(available => {
      const spot = ref.current && ref.current.parentNode.getElementById(`space_${available}`)

      if (!spot) {
        return
      }

      spot.classList.add('spot-available')
    })
  }, [ref, props.available])

  return (
    <svg
      width='100%'
      height='100%'
      viewBox='40 0 300 568'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'>
      <desc>Created with Sketch.</desc>
      <g id='parkingN' stroke='none' strokeWidth='1' fill='none' ref={ref} fillRule='evenodd'>
        <g id='legend' transform='translate(82.000000, 12.000000)'>
          <polygon
            id='Rectangle'
            stroke='#353535'
            strokeWidth='2'
            fill='#FFFFFF'
            points='0 45.2196367 37.0162386 45.2196367 36.9589122 0.0482271881 75.800327 0.00244393967 75.7501242 14.0173534 94.9877793 14.0130848 94.8422525 45.2200532 224 45.2228545 223.575377 517.867332 1.37049407 519'
          />
          <path
            d='M81.5905783,73.2114466 L144.590578,94.3508868 C146.627457,95.0343548 148,96.9426573 148,99.0911464 L148,322.681169 C148,325.994877 145.313708,328.681169 142,328.681169 C141.364235,328.681169 140.732511,328.580123 140.128466,328.381814 L75,307 L75,307 L75,77.9517062 C75,75.1902824 77.2385763,72.9517062 80,72.9517062 C80.54075,72.9517062 81.0779193,73.0394256 81.5905783,73.2114466 Z'
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <path
            d='M7.02439117,47.022768 L34.1064996,47.1454904 C36.8618934,47.1579764 39.0878512,49.397304 39.0838371,52.1527231 L38.7473966,283.096889 C38.7436298,285.682548 37.0838301,287.974972 34.6285358,288.785634 L2.08716286,299.529785 L2.08716286,299.529785 L2.00173423,52.0244425 C2.0007811,49.2630189 4.23858455,47.0236701 7.00000814,47.022717 C7.00813584,47.0227142 7.01626354,47.0227312 7.02439117,47.022768 Z'
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <path
            d='M190.023633,48.0227646 L217.109761,48.1455052 C219.863878,48.1579854 222.089312,50.3953213 222.087102,53.1494653 L221.741087,484.427797 L221.741087,484.427797 L185.087163,496.529785 L185.000976,53.0236849 C185.00044,50.2622612 187.238581,48.0232499 190.000005,48.0227133 C190.007881,48.0227118 190.015757,48.0227289 190.023633,48.0227646 Z'
            id='wall05-copy'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <polygon
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
            points='2 324 39.0910987 311.168078 38.7410873 517.427797 2.08716286 517.529785'
          />
          <path
            d='M75,331 L144.590578,354.350887 C146.627457,355.034355 148,356.942657 148,359.091146 L148,484.829581 C148,487.591005 145.761424,489.829581 143,489.829581 C142.955123,489.829581 142.910248,489.828977 142.865387,489.827769 L79.8653875,488.131036 C77.1573761,488.058103 75,485.841842 75,483.132848 L75,331 L75,331 Z'
            id='wall05'
            stroke='#E6E6E6'
            fill='#F8F8F8'
          />
          <polygon
            id='Triangle'
            fill='#D8D8D8'
            transform='translate(73.800945, 69.177798) rotate(-321.000000) translate(-73.800945, -69.177798) '
            points='73.8009445 67.1777977 75.8009445 71.1777977 71.8009445 71.1777977'
          />
          <polygon
            id='Triangle-Copy-2'
            fill='#D8D8D8'
            transform='translate(69.404743, 65.617824) rotate(-321.000000) translate(-69.404743, -65.617824) '
            points='69.4047431 63.617824 71.4047431 67.617824 67.4047431 67.617824'
          />
          <polygon
            id='Triangle-Copy-3'
            fill='#D8D8D8'
            transform='translate(65.008542, 62.057850) rotate(-321.000000) translate(-65.008542, -62.057850) '
            points='65.0085417 60.0578503 67.0085417 64.0578503 63.0085417 64.0578503'
          />
          <rect
            id='Rectangle'
            fill='#D8D8D8'
            transform='translate(56.500000, 29.500000) rotate(-90.000000) translate(-56.500000, -29.500000) '
            x='29'
            y='29'
            width='55'
            height='1'
          />
          <path
            d='M52.9752006,13.4909212 C52.9316218,13.1148146 52.3025361,12.9608225 52.0291815,12.9114265 C51.9787844,10.9576527 51.8601631,8.18670393 51.5837525,6.96077392 C51.134054,4.96626778 47.0555593,5.00003622 47.0555593,5.00003622 L46.9444391,5.00003622 C46.9444391,5.00003622 42.8659466,4.96626778 42.4162448,6.96077392 C42.1398353,8.18670365 42.021214,10.9576527 41.9708169,12.9114265 C41.6974612,12.9608268 41.0683809,13.1148146 41.0247973,13.4909212 C40.9690034,13.9724468 41.0247973,13.8550005 41.0247973,13.8550005 L41.9555708,13.5692971 C41.9375587,14.4465364 41.9344245,15.0402198 41.9344245,15.0402198 L41.9344245,24.7761224 C41.9344245,24.7761224 42.0950313,26.6692174 42.2556381,28.3256688 C42.4162449,29.9821245 42.8659466,30.6582294 45.0501978,30.8948623 C47.2344479,31.1315037 48.9498039,30.8948623 48.9498039,30.8948623 C51.134054,30.6582294 51.5837525,29.9821245 51.7443603,28.3256688 C51.904966,26.6692174 52.0655738,24.7761224 52.0655738,24.7761224 L52.0655738,15.0402198 C52.0655738,15.0402198 52.0624408,14.4465364 52.0444276,13.5692971 L52.9752006,13.8550005 C52.9752006,13.8550005 53.0309993,13.9724468 52.9752006,13.4909212 Z M43.6603613,11.000226 C44.7271396,10.0290385 46.9487445,10.0000362 46.9487445,10.0000362 L47.0512555,10.0000362 C47.0512555,10.0000362 49.2728604,10.0290384 50.3396377,11.000226 C51.406415,11.9714135 50.9026614,13.1943898 50.7248609,14.2015429 C50.5470683,15.2086988 50.3989059,16.0000362 50.3989059,16.0000362 C50.3989059,16.0000362 48.9189632,15.4604887 47.0512555,15.4604887 L46.9487445,15.4604887 C45.0810338,15.4604887 43.6010981,16.0000362 43.6010981,16.0000362 C43.6010981,16.0000362 43.4529346,15.2086988 43.2751341,14.2015429 C43.0973415,13.1943898 42.593584,11.971413 43.6603613,11.000226 Z M42.0216974,13.0000362 L42.2423864,13.0000362 C42.5366451,14.1626983 42.9044627,15.456631 42.9780229,17.2444382 C42.9885048,17.4991946 42.9956346,17.7506352 43,18.0000362 C42.4816034,17.8217086 42.1756695,17.614988 42.0046503,17.4628496 C41.9879238,14.8937665 42.0216974,13.0000362 42.0216974,13.0000362 Z M42.7016116,23.592314 C42.4288496,25.661681 42.1312873,24.8383804 42.1312873,24.8383804 C42.0569126,22.8732393 42.0183737,20.8391914 42,19.0000362 C42.2762718,19.1225137 42.7288984,19.2087288 43,19.2525877 C42.989072,20.7083749 42.8958823,22.1184569 42.7016116,23.592314 Z M47.0558463,29.0000362 L46.9441537,29.0000362 C43.700555,29.0000362 43,28.3258835 43,28.3258835 C43,28.3258835 43,27.8989189 43.0964207,27.1348703 C43.1928457,26.3708304 43.4191123,25.0000362 43.4191123,25.0000362 C45.2422451,25.3595937 46.9272631,25.3564932 46.9272631,25.3564932 L46.9867072,25.3564932 C46.9867072,25.3564932 48.7577581,25.3595937 50.5808888,25.0000362 C50.5808888,25.0000362 50.8071543,26.3708304 50.9035782,27.1348703 C51,27.8989189 51,28.3258835 51,28.3258835 C51,28.3258835 50.2994417,29.0000362 47.0558463,29.0000362 Z M51.8687079,24.8383804 C51.8687079,24.8383804 51.57115,25.661681 51.2983854,23.592314 C51.1041158,22.1184569 51.0109335,20.7083749 51,19.2525877 C51.2711042,19.2087288 51.7237297,19.1225102 52,19.0000362 C51.9816251,20.8391915 51.9430823,22.8732393 51.8687079,24.8383804 Z M51.9953492,17.462853 C51.8243281,17.6149903 51.5183901,17.8217117 51,18.0000362 C51.0043695,17.7506384 51.0114992,17.4991911 51.0219811,17.2444348 C51.0955478,15.4566291 51.4633624,14.1626973 51.7576102,13.0000362 L51.9783022,13.0000362 C51.9783021,13.0000362 52.012077,14.893768 51.9953492,17.462853 Z'
            id='Shape'
            fill='#D8D8D8'
            transform='translate(47.000000, 18.000018) rotate(-180.000000) translate(-47.000000, -18.000018) '
          />
          <polygon
            id='Triangle-Copy-4'
            fill='#D8D8D8'
            transform='translate(60.612340, 58.497877) rotate(-321.000000) translate(-60.612340, -58.497877) '
            points='60.6123402 56.4978765 62.6123402 60.4978765 58.6123402 60.4978765'
          />
          <polygon
            id='Path-2'
            fill='#D8D8D8'
            points='55.6667172 79 57.3950461 79 57.3950461 105.183916 60 105.183916 56.6299978 121 53 105.213033 55.6667172 105.183916'
          />
          <polygon
            id='Path-2-Copy-2'
            fill='#D8D8D8'
            transform='translate(165.500000, 135.000000) rotate(-180.000000) translate(-165.500000, -135.000000) '
            points='164.666717 114 166.395046 114 166.395046 140.183916 169 140.183916 165.629998 156 162 140.213033 164.666717 140.183916'
          />
          <polygon
            id='Path-2-Copy-3'
            fill='#D8D8D8'
            transform='translate(112.500000, 73.000000) rotate(-252.000000) translate(-112.500000, -73.000000) '
            points='111.666717 52 113.395046 52 113.395046 78.1839156 116 78.1839156 112.629998 94 109 78.2130325 111.666717 78.1839156'
          />
          <polygon
            id='Path-2-Copy-2'
            fill='#D8D8D8'
            transform='translate(164.500000, 431.000000) rotate(-180.000000) translate(-164.500000, -431.000000) '
            points='163.666717 410 165.395046 410 165.395046 436.183916 168 436.183916 164.629998 452 161 436.213033 163.666717 436.183916'
          />
          <polygon
            id='Path-2-Copy'
            fill='#D8D8D8'
            points='56.6667172 413 58.3950461 413 58.3950461 439.183916 61 439.183916 57.6299978 455 54 439.213033 56.6667172 439.183916'
          />
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_62'
          transform='translate(194.000000, 119.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='62'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              62
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_63'
          transform='translate(194.000000, 101.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='63'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              63
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_87'
          transform='translate(268.000000, 69.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='87'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              87
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_1'
          transform='translate(85.000000, 70.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 -2.58637556e-12 34 26 1 15'
          />
          <text id='1' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              1
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_86'
          transform='translate(268.000000, 87.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='86'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              86
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_2'
          transform='translate(85.000000, 88.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='2' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              2
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_85'
          transform='translate(268.000000, 105.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='85'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              85
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_3'
          transform='translate(85.000000, 106.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='3' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              3
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_84'
          transform='translate(268.000000, 123.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='84'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              84
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_4'
          transform='translate(85.000000, 124.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='4' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              4
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_83'
          transform='translate(268.000000, 141.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='83'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              83
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_5'
          transform='translate(85.000000, 142.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='5' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              5
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_82'
          transform='translate(268.000000, 159.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='82'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              82
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_6'
          transform='translate(85.000000, 160.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='6' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              6
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_81'
          transform='translate(268.000000, 177.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='81'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              81
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_7'
          transform='translate(85.000000, 178.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='7' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              7
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_80'
          transform='translate(268.000000, 195.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='80'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              80
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_8'
          transform='translate(85.000000, 196.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='8' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              8
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_79'
          transform='translate(268.000000, 213.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='79'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              79
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_9'
          transform='translate(85.000000, 214.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text id='9' fontFamily='ArialMT, Arial' fontSize='10' fontWeight='normal' fill='#909090'>
            <tspan x='14.2192383' y='15'>
              9
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_78'
          transform='translate(268.000000, 231.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='78'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              78
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_10'
          transform='translate(85.000000, 232.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='10'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              10
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_77'
          transform='translate(268.000000, 249.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='77'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              77
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_11'
          transform='translate(85.000000, 250.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='11'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              11
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_76'
          transform='translate(268.000000, 267.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='76'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              76
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_12'
          transform='translate(85.000000, 268.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='12'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              12
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_75'
          transform='translate(268.000000, 285.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='75'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              75
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_13'
          transform='translate(85.000000, 286.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='13'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              13
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_74'
          transform='translate(268.000000, 303.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='74'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              74
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_73'
          transform='translate(268.000000, 321.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='73'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              73
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_14'
          transform='translate(85.000000, 329.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='14'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              14
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_72'
          transform='translate(268.000000, 339.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='72'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              72
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_15'
          transform='translate(85.000000, 347.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='15'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              15
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_71'
          transform='translate(268.000000, 357.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='71'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              71
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_16'
          transform='translate(85.000000, 365.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='16'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              16
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_70'
          transform='translate(268.000000, 375.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='70'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              70
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_17'
          transform='translate(85.000000, 383.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='17'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              17
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_69'
          transform='translate(268.000000, 393.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='69'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              69
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_18'
          transform='translate(85.000000, 401.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='18'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              18
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_68'
          transform='translate(268.000000, 411.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='68'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              68
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_19'
          transform='translate(85.000000, 419.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='19'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              19
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_67'
          transform='translate(268.000000, 429.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='67'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              67
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_20'
          transform='translate(85.000000, 437.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='20'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              20
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_66'
          transform='translate(268.000000, 447.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='66'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              66
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_21'
          transform='translate(85.000000, 455.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='21'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              21
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_65'
          transform='translate(268.000000, 465.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='65'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              65
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_22'
          transform='translate(85.000000, 473.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='22'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              22
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_64'
          transform='translate(268.000000, 483.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='64'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              64
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_23'
          transform='translate(85.000000, 491.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            transform='translate(17.500000, 13.000000) scale(-1, 1) translate(-17.500000, -13.000000) '
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='23'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              23
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_25'
          transform='translate(158.000000, 107.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='25'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              25
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_24'
          transform='translate(158.000000, 89.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='24'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              24
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_60'
          transform='translate(194.000000, 155.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='60'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              60
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_61'
          transform='translate(194.000000, 137.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='61'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              61
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_27'
          transform='translate(158.000000, 143.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='27'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              27
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_26'
          transform='translate(158.000000, 125.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='26'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              26
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_58'
          transform='translate(194.000000, 191.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='58'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              58
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_59'
          transform='translate(194.000000, 173.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='59'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              59
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_29'
          transform='translate(158.000000, 179.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='29'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              29
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_28'
          transform='translate(158.000000, 161.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='28'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              28
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_56'
          transform='translate(194.000000, 227.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='56'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              56
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_57'
          transform='translate(194.000000, 209.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='57'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              57
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_31'
          transform='translate(158.000000, 215.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='31'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              31
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_30'
          transform='translate(158.000000, 197.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='30'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              30
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_55'
          transform='translate(194.000000, 245.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='55'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              55
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_32'
          transform='translate(158.000000, 233.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='32'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              32
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_53'
          transform='translate(194.000000, 281.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='53'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              53
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_54'
          transform='translate(194.000000, 263.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='54'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              54
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_34'
          transform='translate(158.000000, 269.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='34'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              34
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_33'
          transform='translate(158.000000, 251.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='33'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              33
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_52'
          transform='translate(194.000000, 299.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='52'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              52
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_36'
          transform='translate(158.000000, 305.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='36'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              36
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_35'
          transform='translate(158.000000, 287.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='35'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              35
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_51'
          transform='translate(194.000000, 361.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='51'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              51
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_37'
          transform='translate(158.000000, 349.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='37'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              37
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_50'
          transform='translate(194.000000, 379.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='50'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              50
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_38'
          transform='translate(158.000000, 367.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='38'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              38
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_48'
          transform='translate(194.000000, 415.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='48'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              48
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_49'
          transform='translate(194.000000, 397.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='49'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              49
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_40'
          transform='translate(158.000000, 403.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='40'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              40
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_39'
          transform='translate(158.000000, 385.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='39'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              39
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_47'
          transform='translate(194.000000, 433.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='47'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              47
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_46'
          transform='translate(194.000000, 451.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='46'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              46
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_42'
          transform='translate(158.000000, 439.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='42'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              42
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_41'
          transform='translate(158.000000, 421.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='41'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              41
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_45'
          transform='translate(194.000000, 469.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='45'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              45
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_44'
          transform='translate(158.000000, 475.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='44'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              44
            </tspan>
          </text>
        </g>
        <g
          onClick={props.onSpotClick}
          className='spot'
          id='space_43'
          transform='translate(158.000000, 457.000000)'>
          <polygon
            id='Rectangle'
            stroke='#D3D3D3'
            fill='#DADADA'
            points='1 2.22044605e-14 34 11 34 26 1 15'
          />
          <text
            id='43'
            fontFamily='ArialMT, Arial'
            fontSize='10'
            fontWeight='normal'
            fill='#909090'>
            <tspan x='11.4384766' y='15'>
              43
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  )
}
